import { Box, Typography } from "@mui/material";
import DataLoader from "./DataLoader";
import { useCustomColors } from "../hooks/useCustomColors";

interface LoadingOverlayProps {
  open: boolean;
  message?: string;
}

const LoadingOverlay = ({ open, message = "Please wait..." }: LoadingOverlayProps) => {
  const colors = useCustomColors();

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: colors.tint.scrim,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          p: 4,
          borderRadius: "16px",
          backgroundColor: colors.card.background,
          border: `1px solid ${colors.border.accent}`,
        }}
      >
        <DataLoader />
        <Typography
          variant="body1"
          sx={{
            color: colors.text.primary,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingOverlay;
